import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=18e2c3e6"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports